import React, { useState } from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { FaTimes } from 'react-icons/fa';

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('all');

  const galleryImages = [
    // Training Sessions
    {
      url: 'images/corporatetrainingsession.jpeg',
      title: 'Corporate Training Session',
      category: 'training',
      description: 'Interactive corporate training program in progress'
    },
    {
      url: 'images/workshop.jpg',
      title: 'Coding Bootcamp',
      category: 'training',
      description: 'Students engaged in intensive coding bootcamp'
    },
    {
      url: 'images/ccampusroom.jpeg',
      title: 'Team Collaboration',
      category: 'training',
      description: 'Collaborative learning environment'
    },
    {
      url: 'images/ww.jpg',
      title: 'Technical Workshop',
      category: 'training',
      description: 'Hands-on technical workshop session'
    },
    {
      url: 'images/group discussion.jpeg',
      title: 'Group Discussion',
      category: 'training',
      description: 'Interactive group discussion session'
    },
    {
      url: 'images/business.jpg',
      title: 'Business Analysis Training',
      category: 'training',
      description: 'Professional business analysis seminar'
    },
    
    // Events
    {
      url: 'images/programme launch.jpeg',
      title: 'Program Launch Event',
      category: 'events',
      description: 'Super 50 Program launch ceremony'
    },
    {
      url: 'images/certificationceremany.jpg',
      title: 'Graduation Ceremony',
      category: 'events',
      description: 'Batch completion and certificate distribution'
    },
    {
      url: 'images/techconfernceeee.jpg',
      title: 'Tech Conference',
      category: 'events',
      description: 'Annual technology conference participation'
    },
    {
      url: 'images/networking.jpg',
      title: 'Networking Event',
      category: 'events',
      description: 'Industry networking and career fair'
    },
    {
      url: 'images/wwss.jpg',
      title: 'Workshop Series',
      category: 'events',
      description: 'Weekend workshop series kickoff'
    },
    
    // Achievements
    {
      url: 'images/award.jpg',
      title: 'Award Recognition',
      category: 'achievements',
      description: 'Excellence in training award ceremony'
    },
    {
      url: 'https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?w=800',
      title: 'Team Achievement',
      category: 'achievements',
      description: 'Team celebrating 500+ placements milestone'
    },
    {
      url: 'images/studentsuccess.jpg',
      title: 'Student Success',
      category: 'achievements',
      description: 'Students celebrating successful placements'
    },
    {
      url: 'images/patnershipSuccess.jpg',
      title: 'Partnership Success',
      category: 'achievements',
      description: 'New corporate partnership signing'
    },
    {
      url: 'images/cc.jpg',
      title: 'Certification Ceremony',
      category: 'achievements',
      description: 'Batch certification and recognition'
    },
    
    // Campus & Facilities
    {
      url: 'images/trainingcenterbglr.jpg',
      title: 'Training Center - Bangalore',
      category: 'campus',
      description: 'State-of-the-art training facility in Bangalore'
    },
    {
      url: 'images/modernclassroommm.jpeg',
      title: 'Modern Classroom',
      category: 'campus',
      description: 'Well-equipped modern classroom'
    },
    {
      url: 'images/computerlab.jpg',
      title: 'Computer Lab',
      category: 'campus',
      description: 'Advanced computer lab with latest technology'
    },
    {
      url: 'images/area.jpg',
      title: 'Study Area',
      category: 'campus',
      description: 'Dedicated study and collaboration space'
    },
    {
      url: 'images/confroom.jpg',
      title: 'Conference Room',
      category: 'campus',
      description: 'Conference room for meetings and discussions'
    }
  ];

  const categories = [
    { id: 'all', name: 'All Photos' },
    { id: 'training', name: 'Training Sessions' },
    { id: 'events', name: 'Events' },
    { id: 'achievements', name: 'Achievements' },
    { id: 'campus', name: 'Campus & Facilities' }
  ];

  const filteredImages = selectedCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-blue-900 via-purple-900 to-blue-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6" data-testid="gallery-page-title">
            Our <span className="bg-gradient-to-r from-orange-400 to-yellow-400 bg-clip-text text-transparent">Gallery</span>
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            Capturing moments of learning, growth, and success at Vlinkin Professionals
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map(category => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all ${
                  selectedCategory === category.id
                    ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
                data-testid={`category-${category.id}`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredImages.map((image, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 cursor-pointer"
                onClick={() => setSelectedImage(image)}
                data-testid={`gallery-image-${index}`}
              >
                <div className="aspect-w-16 aspect-h-12 bg-gray-200">
                  <img
                    src={image.url}
                    alt={image.title}
                    className="w-full h-64 object-cover transform group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-xl font-bold mb-2">{image.title}</h3>
                    <p className="text-sm text-white/90">{image.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
          data-testid="lightbox-modal"
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
            onClick={() => setSelectedImage(null)}
            data-testid="close-lightbox"
          >
            <FaTimes size={32} />
          </button>
          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              className="w-full h-auto rounded-lg shadow-2xl"
            />
            <div className="mt-6 text-white text-center">
              <h2 className="text-3xl font-bold mb-2">{selectedImage.title}</h2>
              <p className="text-lg text-white/80">{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default GalleryPage;
